export default {
  state() {
    return {
      lists: {
        advantages: [], // Список преимуществ объекта
        balconies: [], // Балконы
        completion_deadlines: [], // Сроки сдачи
        decorations: [], // Виды отделок
        developers: [], // Список застройщиков
        districts: [], // Районы
        features: [], // Во дворе
        infrastructures: [], // Рядом
        materials: [], // Материал дома
        rooms: [], // Кол-во комнат
        wirings: [], // Разводка
        banks: [], // Банки
      },
    };
  },

  mutations: {
    setItems(state, lists) {
      state.lists = {
        ...state.lists,
        ...lists,
      };
    },
  },

  getters: {
    /* eslint-disable arrow-body-style */
    getItemsAdvantages: state => state.lists.advantages.map(({ id, title, subtitle }) => {
      return {
        id,
        name: `${title} ${subtitle}`.trim(),
      };
    }),

    getItemsBalconies: state => state.lists.balconies.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),

    getItemsBanks: state => state.lists.banks.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),

    getItemsCompletionDeadlines: state => state.lists.completion_deadlines.map(({ key, value }) => {
      return {
        id: key,
        name: value,
      };
    }),

    getItemsDecorations: state => state.lists.decorations.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),

    getItemsDevelopers: state => state.lists.developers.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),

    getItemsDistricts: state => state.lists.districts.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),

    getItemsFeatures: state => state.lists.features.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),

    getItemsInfrastructures: state => state.lists.infrastructures.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),

    getItemsMaterials: state => state.lists.materials.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),

    getItemsRooms: state => state.lists.rooms.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),

    getItemsWirings: state => state.lists.wirings.map(({ id, name }) => {
      return {
        id,
        name,
      };
    }),
  },
};
